export default function createFormActions(formName) {

    const changeValueActionType = `🖊 FORM ${formName} - CHANGE VALUE`
    const changeValueAction = (inputName, value) => ({
        type: changeValueActionType,
        payload: {
            inputName,
            value,
        }
    })

    const patchValuesActionType = `🖊 FORM ${formName} - PATCH VALUES`
    const patchValuesAction = (newValues) => ({
        type: patchValuesActionType,
        payload: newValues

    })

    const resetActionType = `🖊 FORM ${formName} - RESET`
    const resetAction = () => ({type: resetActionType})

    const validateActionType = `🖊 FORM ${formName} - VALIDATE`
    const validateAction = () => ({type: validateActionType})


    return {
        changeValue: changeValueAction,
        reset: resetAction,
        validate: validateAction,
        patchValues: patchValuesAction

    }
}


// WEBPACK FOOTER //
// ./src/redux/actions-reducers/form/create-form-actions.js